module.exports = __webpack_public_path__ + "cw.93e442a0.svg";